import { initDismissibleNotices } from "./plugin/dismissible-notice";
document.addEventListener('DOMContentLoaded', () => {
    initDismissibleNotices();
});
